import * as Model from "../../model"
import { genericFetch } from "./common-service"
import { getBaseHeader } from "./utils"
import { apiBaseUrl } from "./config"

export function findLocalAuthoritySituation(
    localAuthority: Model.LocalAuthority,
    signal: AbortSignal
): Promise<Model.SituationRecord[]> {
    const url = `${apiBaseUrl}/localauthorities/${localAuthority.id}/situations`
    const init: RequestInit = {
        headers: { ...getBaseHeader(), "Content-Type": "application/json" },
        signal
    }
    return genericFetch<Model.SituationRecord[]>(url, init)
}

export function updateLocalAuthoritySituation(
    localAuthority: Model.LocalAuthority,
    file: File,
    signal: AbortSignal
): Promise<Model.SituationRecord[]> {
    const url = `${apiBaseUrl}/localauthorities/${localAuthority.id}/situation`;
    const body = new FormData();
    body.append("situation[file]", file)
    const init: RequestInit = {
        body,
        headers: getBaseHeader(),
        method: "POST",
        signal
    }
    return genericFetch<Model.SituationRecord[]>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/situation-service.ts